import { Link, usePage } from "@inertiajs/react";
import { BarChart3, LayoutDashboard, Lightbulb } from "lucide-react";
import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar.tsx";
import {
  bizminer_app_related_initiatives_path,
  bizminer_app_reports_path,
  bizminer_app_root_path,
} from "@/routes";
import type { BizminerInertiaSharedProps } from "@/types/inertia.ts";

export const DashboardMenuItem = () => {
  const { component } = usePage<BizminerInertiaSharedProps>();

  const isDashboardActive = component === "Bizminer/App/Accounts/Index";
  const isReportsActive = component === "Bizminer/App/Reports/Heatmap";
  const isRelatedInitiativesActive =
    component === "Bizminer/App/RelatedInitiatives/Index";

  return (
    <SidebarGroup>
      <SidebarGroupContent>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton asChild isActive={isDashboardActive}>
              <Link
                href={bizminer_app_root_path(undefined, {
                  account_id: undefined,
                })}
              >
                <LayoutDashboard />
                <span>Accounts</span>
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
          <SidebarMenuItem>
            <SidebarMenuButton asChild isActive={isReportsActive}>
              <Link
                href={bizminer_app_reports_path(undefined, {
                  account_id: undefined,
                })}
              >
                <BarChart3 />
                <span>Reports</span>
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
          <SidebarMenuItem>
            <SidebarMenuButton asChild isActive={isRelatedInitiativesActive}>
              <Link
                href={bizminer_app_related_initiatives_path(undefined, {
                  account_id: undefined,
                })}
              >
                <Lightbulb />
                <span>Use Cases</span>
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  );
};
